import React from "react";
import {
  QuestionIcon,
  //   SettingsIcon,
  //   SoundOffIcon,
  //   SoundOnIcon,
  SupportIcon,
} from "../Icons/Icons";
import "../TradeRoom/TradeRoom.css";

const Footer = ({ setCollapsed, setActiveKeyRoom, setOnOff, onOff }) => {
  return (
    <footer className="footer">
      <div className="display-5">
        <div className="display-1 gap-15">
          <div
            className="display-1 support-btn cursor"
            onClick={() => {
              setCollapsed(false);
              setActiveKeyRoom("support");
            }}
            id="cs"
          >
            <SupportIcon />
            SUPPORT
          </div>
          <div className="display-1 email-sup">
            <QuestionIcon />
            support@gmail.com
          </div>
          {/* <div className="around-clk display-none">
            EVERY DAY, AROUND THE CLOCK
          </div> */}
        </div>
        {/* <div className="display-1 gap-15">
          <div
            className="display-1 cursor"
            id="cs"
            onClick={() => setOnOff(!onOff)}
          >
            {!onOff ? <SoundOffIcon /> : <SoundOnIcon />}
          </div>
          <div className="display-1 cursor" id="cs">
            <SettingsIcon />
          </div>
          <div className="display-1 flex-wrap display-none">
            <div className="around-clk">CURRENT TIME:</div>
            <div className="utc">22 SEPTEMBER,11:09:56</div>
            <div className="around-clk">(UTC+6)</div>
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
